var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAnyBanners)?_c('section',{staticClass:"banners d-flex justify-content-between container banner my-5"},_vm._l((_vm.banners),function(banner,index){return _c('router-link',{key:index,staticClass:"overflow-hidden",attrs:{"to":banner
        ? banner.linkable_type != null
          ? _vm.findUrl(banner.linkable_type, banner.linkable_id)
          : banner.link
        : '',"target":banner && banner.new_tab == 1 ? '_blank' : ''}},[(banner)?_c('img',{staticClass:"w-100",attrs:{"loading":"lazy","src":banner.picture,"alt":""}}):_vm._e()])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }